import { Grid, Typography } from '@mui/material';
import { WithStyles, withStyles } from '@mui/styles';
import { ClientMessagesStatusEnum } from '@tassat/common-definitions';
import React from 'react';
import MarkdownView from 'react-showdown';

import { JS_TIMER_MAX } from 'Lib/constant';
import { useAppSelector } from 'Reducers/store/hooks';
import { getClientBannerMessage } from 'Selectors/clientMessages';

interface IBannerMessage extends WithStyles<typeof muiStyles> {
    className?: string;
}

const muiStyles = () => ({
    banner: {
        fontSize: '18px',
        lineHeight: '25px'
    },
    bannerHtml: { '& > *': { margin: '0px' }}
});

export function BannerMessageComponent(props: IBannerMessage) {
    const { classes } = props;

    const banner = useAppSelector(getClientBannerMessage);

    const [ showBanner, setShowBanner ] = React.useState<boolean>(false);

    React.useEffect(() => {
        const remainingTime = banner?.EndAt ? (Number(banner?.EndAt) - Date.now()) : 0;

        if (remainingTime > 100) {
            setShowBanner(true);

            // If remaining time is too large for a timer, then don't worry about it as it will be multiple days
            if (remainingTime < JS_TIMER_MAX) {
                setTimeout(() => {
                    setShowBanner(false);
                }, remainingTime - 100);
            }
        }
    }, [banner]);

    return (
        <>
            {
                showBanner && banner.Status == ClientMessagesStatusEnum.DISPLAYABLE ?
                    <Grid
                        container
                        direction='column'
                        item
                        md={8}
                        sm={12}
                    >
                        <Typography
                            className={classes.banner}
                            variant='body1'
                        ><strong>IMPORTANT MESSAGE:</strong>
                        </Typography>
                        <div className={classes.bannerHtml} >
                            <MarkdownView markdown={banner?.Message} />
                        </div>
                    </Grid>
                    : null
            }
        </>
    );
}

const BannerMessage = withStyles(muiStyles)(BannerMessageComponent);
export { BannerMessage };